// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__22crq","topBottomGutter":"Layout_topBottomGutter__2eQMo"};